import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const API = process.env.REACT_APP_HOST_API;

const initialState = {
  isLoading: false,
  error: null,
  list: { items: [], total: 0, page: 1, limit: 25 },
  filters: { action: 'all', targetUid: '', actorUid: '' },
};

const slice = createSlice({
  name: 'adminAudit',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setList(state, action) {
      state.isLoading = false;
      state.list = action.payload;
    },
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
});

export default slice.reducer;
export const { setFilters } = slice.actions;

export function fetchAudit({ page = 1, limit = 25 } = {}) {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    try {
      const { filters } = getState().adminAudit;
      const params = { page, limit };
      if (filters.action && filters.action !== 'all') params.action = filters.action;
      if (filters.targetUid) params.targetUid = filters.targetUid;
      if (filters.actorUid) params.actorUid = filters.actorUid;
      const response = await axios.get(`${API}/admin/audit`, { params });
      dispatch(slice.actions.setList(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.error?.message || 'Admin/Audit/Fetch/InternalError'));
    }
  };
}
